import { assignItemProfileRelatedData } from '../../../../utils/items/assign-item-profile-related-data';
export const onItemProfileLoadSuccess = (response, cacheDuration) => {
    const { itemProfile, relatedData } = response;
    assignItemProfileRelatedData(relatedData, cacheDuration);
    return itemProfile;
};
